/* eslint-disable no-nested-ternary */
import React, { useContext, useState } from "react";
import { Button } from "reactstrap";
import { StoreContext } from "components/StoreContext";
import {
  CarouselProvider,
  Slider,
  Slide,
  DotGroup,
  ButtonBack,
  ButtonNext
} from "pure-react-carousel";
import OverlayLeft from "components/Images/OverlayLeft.svg";
import OverlayRight from "components/Images/OverlayRight.svg";
import OverlayCenter from "components/Images/OverlayCenter.svg";
import "pure-react-carousel/dist/react-carousel.es.css";

const Hero = () => {
  const { store } = useContext(StoreContext);
  const [playCarousel, setPlayCarousel] = useState(false);

  let validatedArray = [];

  const oneH1 = (title, text, index) => {
    if (index === 0 && title) {
      return (
        <h1
          id={`title_${index}`}
          dangerouslySetInnerHTML={{
            __html: text
          }}
        />
      );
      // eslint-disable-next-line no-else-return
    } else if (index !== 0 && title) {
      return (
        <h2
          className="nonH1Title"
          dangerouslySetInnerHTML={{
            __html: text
          }}
        />
      );
    } else if (index === 0 && title === false) {
      return (
        <h2
          className="h2h3"
          dangerouslySetInnerHTML={{
            __html: text
          }}
        />
      );
    } else {
      return (
        <h3
          dangerouslySetInnerHTML={{
            __html: text
          }}
        />
      );
    }
  };

  if (store.sliderBanners) {
    validatedArray = store.sliderBanners.filter(
      slide => slide.mediaPath !== "" && slide.bannerTitle !== ""
    );
  }

  if (store.sliderBanners && store.sliderBannerSettings) {
    return (
      <div
        className="heroContainer"
        onMouseEnter={
          store.sliderBannerSettings.autoplayHoverPause &&
          (() => setPlayCarousel(false))
        }
        onMouseLeave={
          store.sliderBannerSettings.autoplayHoverPause &&
          (() => setPlayCarousel(true))
        }
      >
        <div className="heroContainer__content">
          <CarouselProvider
            id="carouselProvider"
            naturalSlideWidth={100}
            naturalSlideHeight={50}
            totalSlides={validatedArray.length}
            isPlaying={
              store.sliderBannerSettings.autoPlay === true
                ? playCarousel
                : false
            }
            interval={
              store.sliderBannerSettings.autoplayTimeOut
                ? store.sliderBannerSettings.autoplayTimeOut
                : 10000
            }
          >
            <ButtonBack aria-label="Button Back" />
            <Slider>
              {validatedArray.map((slide, index) => (
                <Slide
                  id={`slide_${index}`}
                  key={`${slide.bannerTitle}${slide.buttonLink}`}
                  // aria-hidden={currentSlideBannerIdx === index ? "false" : "true"}
                >
                  <div className="heroContainer__wrapper">
                    <div
                      id={slide.mediaPath}
                      className={`heroContainer__image ${slide.textAlignment}`}
                      style={{
                        backgroundImage: `url("${store.mediaServerUrl +
                          encodeURIComponent(slide.mediaPath)}")`
                      }}
                    >
                      <div
                        style={{
                          backgroundImage: `url(${
                            slide.textAlignment === "Left"
                              ? OverlayLeft
                              : slide.textAlignment === "Right"
                              ? OverlayRight
                              : OverlayCenter
                          })`
                        }}
                        className={`heroBannerContainer ${slide.textAlignment}`}
                      >
                        <div>
                          {oneH1(true, slide.bannerTitle, index)}
                          {slide.bannerSubTitle &&
                            slide.bannerSubTitle !== `&nbsp;` &&
                            oneH1(false, slide.bannerSubTitle, index)}
                          {slide.buttonLink && (
                            <div>
                              <Button block color="primary">
                                {slide.buttonText ? (
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: slide.buttonText
                                    }}
                                  />
                                ) : (
                                  <span>Learn More</span>
                                )}
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {validatedArray.length > 1 && (
                      <a
                        title="link"
                        href={slide.buttonLink}
                        id={`slideLink_${index}`}
                      >
                        {" "}
                      </a>
                    )}
                  </div>
                  <span
                    role="img"
                    className="sr-only"
                    aria-label={slide.imageAlternateText}
                  />
                </Slide>
              ))}
            </Slider>
            <ButtonNext aria-label="Button Next" />
            {validatedArray.length > 1 && <DotGroup />}
          </CarouselProvider>
        </div>
      </div>
    );
  }
  return null;
};

export default Hero;
